import { useMutation, useQueryClient } from "@tanstack/react-query"
import { saveEnergyPassport } from "@/entities/energy-passport/api/save-energy-passport.ts"
import type { IEnergyPassportPayload, ISaveEnergyPassportParams } from "@/entities/energy-passport/types.ts"
import { energyPassportQueryKeys } from "@/features/energy-passport/api/query-keys.ts"

interface IMutationPayload {
  params: ISaveEnergyPassportParams
  payload: IEnergyPassportPayload
}

export const useSaveEnergyPassport = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ params, payload }: IMutationPayload) => saveEnergyPassport(params as ISaveEnergyPassportParams, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: energyPassportQueryKeys.lists() })
    }
  })
}
